(( $, wp ) => {

    const { __, _x, _n, _nx } = wp.i18n;
    const { Fragment } = wp.element;
    const { SelectControl, TextControl, PanelBody, PanelRow } = wp.components;
    if (typeof wp.blockEditor != "undefined") var { InspectorControls } = wp.blockEditor;
    else var { InspectorControls } = wp.editor;


    wp.blocks.registerBlockType( 'discord-wordpress-plugin/dwpp-synchronization-gutenberg-block', {

        // Block setup
        title: __('Synchronize Discord Profile Button', 'discord-wordpress-plugin'),
        description: <p>
                        { __('Block outputs an HTML link to start the synchronization of Discord profile data and roles in both directions.', 'discord-wordpress-plugin') }
                        <br/><br/>
                        <i>{ __('If WP user is not authorized shortcode will return nothing.', 'discord-wordpress-plugin') }</i>
                    </p>,
        icon: <svg width="430" height="430" viewBox="0 0 430 430">
                <path fill="#72d0da" d="M72.2 0C32.2012 0 0 32.2012 0 72.2V288.8C0 328.799 32.2012 361 72.2 361H288.8C328.799 361 361 328.799 361 288.8V72.2C361 32.2012 328.799 0 288.8 0H72.2ZM175.579 51.3579C219.81 51.3579 258.609 75.0495 280.078 110.366L305.433 94.967L306.746 178.205C306.758 178.969 305.945 179.463 305.273 179.102L231.837 139.662L258.757 123.318C241.759 95.1917 210.958 76.4164 175.579 76.4164C134.237 76.4164 99.0902 101.776 84.9901 138.026C84.6757 138.994 84.4649 139.957 83.9678 141.086C80.4903 148.812 72.5236 152.772 66.1716 149.928C62.0095 148.055 59.4078 143.592 59.3746 138.259C59.4326 135.713 60.3772 132.689 61.511 129.699C79.2099 83.9375 123.676 51.3579 175.579 51.3579ZM54.2544 182.795C54.2424 182.031 55.0551 181.537 55.7274 181.898L129.163 221.338L102.243 237.682C119.241 265.808 150.042 284.584 185.421 284.584C226.763 284.584 261.91 259.224 276.01 222.974C276.324 222.006 276.535 221.043 277.032 219.914C280.51 212.188 288.476 208.228 294.828 211.072C298.991 212.945 301.592 217.408 301.625 222.741C301.567 225.287 300.623 228.311 299.489 231.301C281.79 277.062 237.324 309.642 185.421 309.642C141.19 309.642 102.39 285.95 80.9218 250.634L55.5672 266.033L54.2544 182.795Z"/>
                <rect x="238" y="238" width="177" height="145" fill="white"/>
                <path fill="#7289DA" d="M355.17,317.14a10.72,10.72,0,0,1-10.69,10.71,11.06,11.06,0,0,1-7.62-3.18,10.3,10.3,0,0,1-3.07-7.45,10.72,10.72,0,0,1,10.69-10.71v0A10.66,10.66,0,0,1,355.17,317.14Zm-47.47-10.67,0,0A10.72,10.72,0,0,0,297,317.21a10.3,10.3,0,0,0,3.07,7.45,11.06,11.06,0,0,0,7.62,3.18,10.69,10.69,0,0,0,0-21.38ZM430,237.17V430l-25.28-20.36-13.83-12-15.15-12.52L382,404.88H249.65c-13.21,0-24-9.57-24-22.17V237.22c0-12,10.74-22.17,24-22.17l155.72,0C418.66,215,429.34,225.18,430,237.17ZM347.27,266l.32-.09h-.23Zm49.49,74.23c0-34.65-17.13-62.87-17.13-62.87-15.32-10.8-29.62-11.28-32.32-11.28l-1.74,1.63c19.56,5.38,29,13.76,29,13.76a109.65,109.65,0,0,0-87.07-3.61c-4.43,1.81-6.95,3-6.95,3s9.42-9,30.26-13.76l-1.28-1.19s-15.82-.57-32.82,11.37c0,0-17.05,28.13-16.89,63,0,0,9.42,15.61,35.29,16.18,0,0,3.75-4.81,7.59-9-14.54-4.19-20.2-12.57-20.2-12.57l4.85,2.38c14.21,5.55,29.25,12.56,56,8.37,5.62-1.23,11.29-2.42,17-4.8,3.67-1.81,8.19-3.61,13.17-6.61,0,0-5.65,8.38-20.79,12.57,3.11,4.19,7.5,9,7.5,9C386.16,355.19,396.22,339.61,396.77,340.24Z"/>
            </svg>,
        category: 'discord-wordpress-plugin-blocks',


        // Custom attributes
        attributes: {
            text: {
                type: 'string',
                default: __('Synchronize Data', 'discord-wordpress-plugin'),
            },
            styling: {
                type: 'string',
                default: 'no',
            },
        },


        // Main editor function
        edit: props => {

            return [

                // Sidebar controls
                <Fragment>
                    <InspectorControls>
                        <PanelBody title={'View'} initialOpen={true}>
                            <PanelRow>
                                <TextControl
                                    label={ __('Button text', 'discord-wordpress-plugin') }
                                    value={ props.attributes.text }
                                    onChange={ value => props.setAttributes({ text: value }) }/>
                            </PanelRow>
                            <PanelRow>
                                <SelectControl
                                    label={ __('Style', 'discord-wordpress-plugin') }
                                    onChange={ value => props.setAttributes({ styling: value }) }
                                    options={[
                                        { value: 'no', label: __('None', 'discord-wordpress-plugin') },
                                        { value: 'default', label: __('Default', 'discord-wordpress-plugin') }
                                    ]}
                                    value={ props.attributes.styling }/>
                            </PanelRow>
                        </PanelBody>
                    </InspectorControls>
                </Fragment>,

                // Output in editor
                <a className={"dwpp__synchronization dwpp__button--" + props.attributes.styling + "-style"} href="javascript:void(0)">
                    { props.attributes.text }
                </a>
            ];
        },


        // Front end save
        save: () => {
            return null;
        },

    });
})( jQuery, wp );
